<!--
  IsFraudulentFilter renders a filter with dropdown options for fraudulent
  status and reads/writes from the `is_fraudulent` URL query param.
-->

<script>
import { iFilter } from '@inscribe/signal';
import { getAndSyncQueryParams, updateQueryParams } from '@/utils/queryParams';

export default {
  components: {
    iFilter,
  },
  data() {
    return {
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
      options: [{ label: 'True' }, { label: 'False' }],
    };
  },
  computed: {
    value() {
      const { is_fraudulent } = this.params;
      if (typeof is_fraudulent === 'undefined') {
        return [];
      }
      return [is_fraudulent ? 'True' : 'False'];
    },
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
  },
  methods: {
    onSelectionChanged(updated) {
      const updatedSelection = updated.selection[0];
      const updatedParam = updatedSelection
        ? updatedSelection.label === 'True'
        : undefined;
      updateQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
        updates: {
          is_fraudulent: updatedParam,
        },
      });
    },
  },
};
</script>

<template>
  <iFilter
    label="Fraudulent"
    :options="options"
    :value="value"
    :max-selectable="1"
    :searchable="false"
    @selection-changed="onSelectionChanged"
  />
</template>
